"use client";

import { Typography, Button, Container } from "@repo/ui";
import { useEffect } from "react";

import { Home } from "lucide-react";
import Image from "next/image";

function NotFoundScreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-[inherit] flex items-center justify-center bg-gradient-to-b from-blue-50/50 to-blue-100/50">
      <Container className="container mx-auto px-4 py-16 text-center">
        <div className="max-w-2xl mx-auto">
          {/* 404 Image Illustration */}
          <div className="relative mb-8">
            <Image
              src="/images/404Error.svg"
              alt="Page not found illustration"
              width={300} // You can adjust width and height as needed
              height={200}
              className="mx-auto w-auto h-auto"
              priority
            />
          </div>

          {/* Error Message */}
          <Typography
            variant="h2"
            className="text-3xl font-bold text-gray-800 mb-4 mt-8"
          >
            Oops! Page Not Found
          </Typography>
          <Typography className="text-gray-600 mb-8">
            {`The page you're looking for doesn't exist or has been moved.`}
          </Typography>

          {/* Action Button */}

          <Button
            color="primary"
            variant="contained"
            className="inline-flex items-center gap-2"
            href="/"
          >
            <Home className="w-5 h-5" />
            Back to Home
          </Button>
        </div>
      </Container>
    </div>
  );
}
export default NotFoundScreen;
